/* eslint-disable camelcase */
import { put, select, delay } from 'redux-saga/effects';
import {
    VALIDATE_PRODUCTS_SUCCESS,
    VALIDATE_PRODUCTS_FAILURE,
} from '../actions/actionTypes';
import {
    convertObjectToQueryParams,
    generate_UUID,
    limitQuantityTo50,
} from 'src/utils/util';
import { setCartData } from 'src/pages/equity/redux/actions';
import { TISSUE_AND_NON_TISSUE_SALES_ORG } from 'src/constants/productConstants';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { filterProductsWithQuantityGreaterThanZero } from 'src/utils/util';
import { getEquityValidateProductsDataServices } from 'src/pages/equity/services';
import { getValidatedProductsEndpoint } from 'src/pages/equity/services/endpoints';
import { SET_PRODUCT_TO_BE_ADDED } from 'src/pages/more/pages/templates/redux/action/actionTypes';
import {setData} from 'src/pages/more/pages/templates/redux/action/index.js';

const validateTissueAndNonTissueSalesOrgs = (
    { products, orderType },
    soldToAccount
) => {
    /*const url = `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/products/validateproduct?`;*/

    // const tissueSalesOrg = [];
    // const nonTissueSalesOrg = [];
    // const otherSalesOrg = [];
    // const otherSalesOrgItems = [];
    const promiseArray = [];
    const groupProductsBySalesOrg = products.reduce((prev, curr) => {
        prev[curr.salesOrg] = prev[curr.salesOrg] || [];
        prev[curr.salesOrg].push(curr.cfn || curr.productCFN);
        return prev;
    }, {});
    // products.forEach((product) => {
    //     if (product.salesOrg === TISSUE_AND_NON_TISSUE_SALES_ORG.tissue)
    //         tissueSalesOrg.push(product.cfn);
    //         else if (product.salesOrg === TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue)
    //         nonTissueSalesOrg.push(product.cfn || product.productCFN);
    //     else {
    //         otherSalesOrgItems.push(product.cfn || product.productCFN);
    //         otherSalesOrg.push(product.salesOrg);
    //     }
    // });

    /*if (tissueSalesOrg.length > 0) {
        const tissueUrl = `${url}${convertObjectToQueryParams({
            productCFN: tissueSalesOrg.join(),
            salesOrg: TISSUE_AND_NON_TISSUE_SALES_ORG.tissue,
            soldToAccount,
            orderType,
        })}`;*/

    /*  const tissuePromise = axios
            .get(tissueUrl)
            .then((response) => response.data);
        promiseArray.push(tissuePromise);*/

    Object.keys(groupProductsBySalesOrg).map((salesOrg) => {
        const salesOrgPromise = getEquityValidateProductsDataServices(
            convertObjectToQueryParams({
                productCFN: groupProductsBySalesOrg[salesOrg].join(),
                salesOrg: salesOrg,
                soldToAccount,
                orderType,
            })
        );
        promiseArray.push(salesOrgPromise);
    });

    // if (tissueSalesOrg.length > 0) {
    //     const tissuePromise = getEquityValidateProductsDataServices(
    //         convertObjectToQueryParams({
    //             productCFN: tissueSalesOrg.join(),
    //             salesOrg: TISSUE_AND_NON_TISSUE_SALES_ORG.tissue,
    //             soldToAccount,
    //             orderType,
    //         })
    //     );

    //     promiseArray.push(tissuePromise);
    // }

    /*if (nonTissueSalesOrg.length > 0) {
        const nonTissueUrl = `${url}${convertObjectToQueryParams({
            productCFN: nonTissueSalesOrg.join(),
            salesOrg: TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue,
            soldToAccount,
            orderType,
        })}`;*/

    /*const nonTissuePromise = axios
            .get(nonTissueUrl)
            .then((response) => response.data);
        promiseArray.push(nonTissuePromise);*/

    // if (nonTissueSalesOrg.length > 0) {
    //     const nonTissuePromise = getEquityValidateProductsDataServices(
    //         convertObjectToQueryParams({
    //             productCFN: nonTissueSalesOrg.join(),
    //             salesOrg: TISSUE_AND_NON_TISSUE_SALES_ORG.nonTissue,
    //             soldToAccount,
    //             orderType,
    //         })
    //     );
    //     promiseArray.push(nonTissuePromise);
    // }

    // const getProductsPrice = getPricesForItemsDataService(
    //     convertObjectToQueryParams({
    //         productCFN: nonTissueSalesOrg.join(),
    //         sapPartnerId: soldToAccount,
    //         orderType,
    //     })
    // );
    // productsPrice.push(getProductsPrice);
    // const allPromise = Promise.all([promiseArray, productsPrice]);
    // return allPromise;
    return Promise.all(promiseArray);
};

export default function* validateProducts(action) {
    const { soldToAccount, inventoryShipping } = yield select((state) => ({
        soldToAccount: state.equityReducer.equityDetails?.accountId?.accountId,
        inventoryShipping: state.equityReducer.equityDetails.inventoryShipping,
    }));
    const { searchType } = action?.payload || {};
    try {
        let result = [];
        let results = [];
        var productsPrice = [];
        var productsPriceResults = [];
        results = yield validateTissueAndNonTissueSalesOrgs(
            action.payload,
            soldToAccount
        );
        // const productsDetailsresults =
        //     yield validateTissueAndNonTissueSalesOrgs(
        //         action.payload,
        //         soldToAccount
        //     );
        // results.push(
        //     yield productsDetailsresults[0][0].then((count) =>
        //         Object.assign({}, count)
        //     )
        // );
        // productsPrice.push(
        //     yield productsDetailsresults[1][0].then((count) =>
        //         Object.assign({}, count)
        //     )
        // );
        results.forEach(({ products }) => {
            result = [...result, ...products];
        });
        productsPrice.forEach(({ priceDetails }) => {
            productsPriceResults = [...productsPriceResults, ...priceDetails];
        });
        if (action.payload.templateScreen) {
            if (result?.length > 0) {
                yield put({
                    type: VALIDATE_PRODUCTS_SUCCESS,
                    validatedProducts: [],
                    templateProducts: results[0]?.products,
                });
            }
        } else {
            const { products } = action.payload;
            const productsForValidation = [];
            products.forEach((product) => {
                const index = productsForValidation.findIndex(
                    (item) => (item.cfn || item.productCFN) === (product.cfn || product.productCFN)
                );
                if (index === -1) {
                    productsForValidation.push({
                        ...product,
                        quantity: Number(product.quantity),
                    });
                } else {
                    productsForValidation[index].quantity =
                        productsForValidation[index]?.quantity +
                        Number(product.quantity);
                }
            });
            const validatedProducts = result;
            const productsToBeAddedToCart = [];
            let validatedProductIndex = 0;

            // calculating products to be added to cart and adding description
            validatedProducts.forEach((validatedProduct) => {
                validatedProductIndex = productsForValidation.findIndex(
                    (product) => (product.cfn || product.productCFN) === (validatedProduct.productCFN || validatedProduct.cfn)
                );
                validatedProduct.description =
                    productsForValidation[validatedProductIndex]?.description;
                validatedProduct.salesOrg =
                    productsForValidation[validatedProductIndex]?.salesOrg;
                validatedProduct.isSet =
                    productsForValidation[validatedProductIndex]?.isSet;
                // validatedProduct.basePrice =
                //     productsPriceResults[validatedProductIndexValue].basePrice;validatedProduct
                validatedProduct.implantable= validatedProducts[validatedProductIndex]?.implantable;
                validatedProduct.instrument= validatedProducts[validatedProductIndex]?.instrument;
                if (
                    !validatedProduct.isExcluded &&
                    !validatedProduct.isExcludedExtraItem
                    // && !(
                    //     (inventoryShipping &&
                    //         productsForValidation[validatedProductIndex]
                    //             .salesOrg ===
                    //             TISSUE_AND_NON_TISSUE_SALES_ORG.tissue) ||
                    //     (inventoryShipping &&
                    //         !productsForValidation[validatedProductIndex].isSet)
                    // )
                ) {
                    productsToBeAddedToCart.push({
                        ...productsForValidation[validatedProductIndex],
                        quantity: productsForValidation[validatedProductIndex]
                            ?.quantity
                            ? productsForValidation[validatedProductIndex]
                                  ?.quantity
                            : 1,
                        isProductFamily:
                            validatedProduct?.productFamily !== '' &&
                            validatedProduct?.productFamily?.split(',')
                                ?.length > 0
                                ? true
                                : false,
                        productFamily:
                            validatedProduct?.productFamily !== '' &&
                            validatedProduct?.productFamily?.split(',')
                                ?.length > 0
                                ? validatedProduct?.productFamily?.split(',')
                                : [],
                        implantable: validatedProduct?.implantable,
                        instrument: validatedProduct?.instrument,
                    });
                }
            });

            yield put({
                type: VALIDATE_PRODUCTS_SUCCESS,
                validatedProducts: validatedProducts.map((product) => ({
                    ...product,
                    productAdded:
                        searchType === 'productSearch' &&
                        productsToBeAddedToCart.length === 1,
                    nonInventoryShipping:
                        !product.isExcluded && !product.isExcludedExtraItem
                            ? (inventoryShipping &&
                                  product.salesOrg ===
                                      TISSUE_AND_NON_TISSUE_SALES_ORG.tissue) ||
                              (inventoryShipping && !product.isSet)
                            : false,
                    productFamily: result[0]?.productFamily
                        ? result[0]?.productFamily.split(',')
                        : [],
                    basePrice: product.basePrice,
                    implantable: product?.implantable,
                    instrument: product?.instrument,
                })),
                statusCode: results[0]?.statusCode,
                statusMessage: results[0]?.statusMessage,
            });
            // Copy flows (order history / order listing) pre-fill the cart with
            // the source order's products WITHOUT going through the normal
            // add-to-cart validation. `validateOnly` runs the validate API purely
            // to detect invalid items and RECONCILE the existing cart: keep the
            // valid products and drop the excluded ones, so the order can proceed
            // with the valid items. It must NOT merge/re-add products (that would
            // duplicate the already-present copied items), so return early and
            // skip the normal add-to-cart merge below.
            if (action.payload.validateOnly) {
                if (validatedProducts && validatedProducts.length > 0) {
                    const validCFNs = new Set(
                        validatedProducts
                            .filter(
                                (p) =>
                                    !p.isExcluded &&
                                    !p.isExcludedExtraItem &&
                                    !p.isInvalidItemMsg
                            )
                            .map((p) => p.productCFN || p.cfn)
                    );
                    const cartProductsToReconcile = yield select(
                        (state) => state.equityReducer.cartData.products
                    );
                    const reconciledProducts = cartProductsToReconcile.filter(
                        (product) => {
                            const key =
                                product.parentCFN ||
                                product.productCFN ||
                                product.cfn;
                            return validCFNs.has(key);
                        }
                    );
                    if (
                        reconciledProducts.length !==
                        cartProductsToReconcile.length
                    ) {
                        yield put(
                            setCartData({
                                products: reconciledProducts,
                                getPricesForItems: reconciledProducts,
                            })
                        );
                    }
                }
                return;
            }
            // Logic for stopping duplicate entry.
            const existingProducts = yield select(
                (state) => state.equityReducer.cartData.products
            );
            const clonedExistingProducts = [
                ...filterProductsWithQuantityGreaterThanZero(existingProducts),
            ];
            productsToBeAddedToCart.forEach((product) => {
                product.quantity = +product.quantity;
                const productIndex = clonedExistingProducts.findIndex(
                    (item) => item.productCFN === product.cfn
                );
                product.productCFN = product.cfn;
                // eslint-disable-next-line no-self-assign
                product.implantable= product?.implantable;
                 // eslint-disable-next-line no-self-assign
                product.instrument= product?.instrument;
                // clonedExistingProducts[productIndex].basePrice =
                //     productsPriceResults.length > 0
                //         ? productsPriceResults[productPriceIndex].basePrice
                //         : 0;
                // delete product.cfn;
                if (product.salesOrg === 'S002')
                    product.shippingRequirement = true;
                // product.batchParked = false;
                if (productIndex !== -1 && !product.isSet) {
                    const index = clonedExistingProducts.some((item) => {
                        if (item.productCFN == product.productCFN) {
                            return true;
                        }
                    });
                    if (index && product.materialType == 'ZKMT') {
                        // const prod = clonedExistingProducts.filter(
                        //     (item) => product.productCFN === item.productCFN
                        // );

                        // const existingQuantity =
                        //     product.materialType === 'ZKMT' && prod.length > 0
                        //         ? prod.reduce(
                        //               (prev, current) =>
                        //                   prev + parseInt(current.quantity),
                        //               0
                        //           )
                        //         : 0;

                        // if (parseInt(existingQuantity) < 50) {
                        clonedExistingProducts.push({
                            ...product,
                            productKey: generate_UUID(),
                        });
                        // }
                    } else {
                        const quantity = limitQuantityTo50(
                            parseInt(
                                clonedExistingProducts[productIndex]?.quantity
                            ) + parseInt(product.quantity)
                        );

                        clonedExistingProducts[productIndex].quantity =
                            quantity;
                    }
                } else if (productIndex === -1 && !product.isSet) {
                    clonedExistingProducts.push({
                        ...product,
                        productKey: generate_UUID(),
                    });
                } else {
                    for (let i = 1; i <= Number(product.quantity); i++) {
                        let productModified = {
                            ...product,
                            productKey: generate_UUID(),
                            quantity: 1,
                        };
                        clonedExistingProducts.push(productModified);
                    }
                }
            });
            // updating cart data
            if (!action.payload.productType) {
                yield put(
                    setCartData({
                        products: clonedExistingProducts,
                        getPricesForItems: clonedExistingProducts,
                    })
                );
            }

            // Added a delay of 1200ms for showing added and tick mark in ui
            // this will re-render the ui with productAdded as false, so tick mark will disapper after 1200ms
            if (
                searchType === 'productSearch' &&
                productsToBeAddedToCart.length >= 1
            ) {
                yield delay(500);
                yield put({
                    type: VALIDATE_PRODUCTS_SUCCESS,
                    validatedProducts: [
                        {
                            productCFN: result[0]?.productCFN,
                            productAdded: false,
                            isExcluded: result[0]?.isExcluded,
                            productFamily: result[0]?.productFamily
                                ? result[0]?.productFamily.split(',')
                                : [],
                        },
                    ],
                    statusCode: results[0]?.statusCode,
                    statusMessage: results[0]?.statusMessage,
                });
                yield put(setData([]));
            } 
            var data = [];
            let validatedData = [];
            validatedData = validatedProducts.map((product) => ({
                ...product,
                productAdded:
                    searchType === 'productSearch' &&
                    productsToBeAddedToCart.length === 1,
                nonInventoryShipping:
                    !product.isExcluded && !product.isExcludedExtraItem
                        ? (inventoryShipping &&
                              product.salesOrg ===
                                  TISSUE_AND_NON_TISSUE_SALES_ORG.tissue) ||
                          (inventoryShipping && !product.isSet)
                        : false,
                productFamily: result[0]?.productFamily
                    ? result[0]?.productFamily.split(',')
                    : [],
                basePrice: product.basePrice,
                implantable: product?.implantable,
                instrument: product?.instrument,
            }));
            data = action.payload.products?.map((targetItem) => {
                const sourceItem = validatedData?.find(
                    (sourceItem) =>
                        sourceItem?.productCFN === targetItem?.cfn
                );
                return sourceItem
                    ? {
                          ...targetItem,
                          implantable: sourceItem.implantable,
                          instrument: sourceItem.instrument,
                      }
                    : targetItem;
            });
            yield put({
                type: SET_PRODUCT_TO_BE_ADDED,
                payload: data,
            });

        }
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/products/validateproduct`,
            requestPayload: action.payload
        });
        yield put({
            type: VALIDATE_PRODUCTS_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}
